import {MOON_500} from '@wandb/weave/common/css/color.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const AliasOption = styled.div`
  display: flex;
  align-items: center;
`;
AliasOption.displayName = 'S.AliasOption';

export const Alias = styled.div`
  flex: 1 1 auto;
`;
Alias.displayName = 'S.Alias';

export const AliasVersion = styled.div`
  color: ${MOON_500};
`;
AliasVersion.displayName = 'S.AliasVersion';
